import { addEventListener } from './uf-functions.js'

class CollapseBlock {
    constructor(attributes) {
        this.attributes = attributes
        
        if (this.attributes.length == 0) return

        this.onClick = this.onClick.bind(this)
        this.onResize = this.onResize.bind(this)
        this.showBlock = this.showBlock.bind(this)
        this.collapseBlock = this.collapseBlock.bind(this)
        this.showAll = this.showAll.bind(this)
        this.collapseAll = this.collapseAll.bind(this)
        this.init = this.init.bind(this)

        this.init()
    }

    init() {
        const { wrappers } = this.attributes;

        if ( !wrappers || wrappers.length == 0 ) return

        [...wrappers].forEach( wrapper => {
            const wrapperClasses = wrapper.getAttribute('class').split(' ')

            const blocks = [ ...wrapper.querySelectorAll('.acv-collapse') ]
            const btnExpandAll = [ ...wrapper.querySelectorAll('.acv-collapse-expand-all') ]
            const btnCollapseAll = [ ...wrapper.querySelectorAll('.acv-collapse-collapse-all') ]

            blocks.map( ( block, index ) => {
                const trigger = block.querySelector('.acv-collapse-trigger')
                const panel = block.querySelector('.acv-collapse-panel')
    
                trigger.onclick = e => this.onClick(block, panel)
                this.onResize(block, panel)

                const id = block.getAttribute('id')
                if ( id && id === window.location.hash.substring(1) ) {
                    this.showBlock(block, panel)
                }
            })

            addEventListener( window, 'hashchange', e => {
                blocks.map( block => {
                    const panel = block.querySelector('.acv-collapse-panel')

                    const id = block.getAttribute('id')
                    if ( id && id === window.location.hash.substring(1) ) {
                        this.showBlock(block, panel)
                    }
                })
            })

            addEventListener( window, 'resize', e => {
                blocks.map( block => {
                    const panel = block.querySelector('.acv-collapse-panel')
                    this.onResize(block, panel)
                })
            })

            btnExpandAll.forEach( btn => btn.onclick = e => {
                e.preventDefault()
                this.showAll(blocks)
            })
            btnCollapseAll.forEach( btn => btn.onclick = e => {
                e.preventDefault()
                this.collapseAll(blocks)
            })
        })
    }

    onResize(block, panel) {
        block.hasAttr('class', 'acv-collapse__active') ? this.showBlock(block, panel) : this.collapseBlock(block, panel)
    }

    onClick(block, panel) {
        block.hasAttr('class', 'acv-collapse__active') ? this.collapseBlock(block, panel) : this.showBlock(block, panel)
    }

    showBlock(block, panel) {
        block.addClass('acv-collapse__active')
        panel.style.height = `${parseFloat(panel.children[0].offset().height)}px`
    }

    collapseBlock(block, panel) {
        block.rmClass('acv-collapse__active')
        panel.style.height = 0
    }

    showAll(blocks) {
        blocks.forEach( block => this.showBlock(block, block.querySelector('.acv-collapse-panel')) )
    }

    collapseAll(blocks) {
        blocks.forEach( block => this.collapseBlock(block, block.querySelector('.acv-collapse-panel')) )
    }
}

export default CollapseBlock